export enum DtoServiceUpdateType {
  None,
  Add,
  Update,
  Remove
}
